import { createContext } from 'react';
import type { SpaceNounPair } from '../../lib/spaceNoun';

/**
 * Customer-portal "space" noun context. `BrandedShell` provides the pair it
 * receives from `GET /api/customer/branding`; `useSpaceNoun()` reads it and
 * falls back to the platform default ("run"/"runs") when no shell is mounted.
 */
export const SpaceNounContext = createContext<SpaceNounPair | null>(null);
